import { combineBaseReducerAndFieldsCoreFn } from "./combineReducersDomain";
import { ICombineBaseReducerAndFieldsCfg } from "./combineReducersModel";
import { produce } from "immer";

/** Has base reducer function and add some fields named as in subReducers object.
 * {subReducers} object and object from {getSubReducers} will be merged.
 * Use Immer to extend nextState.
 * @param baseReducer ordinary reducer for generate next state
 * @param subReducers object of reducers, each field will add same field to state
 * @param getSubReducers function that may return object of reducers
 */
export function combineBaseReducerAndFieldsImmer(
    cfg: ICombineBaseReducerAndFieldsCfg
) {
    const r: any = (state = null, action, ...other) => {
        const [
            newState,
            keys,
            activeSubReducers,
        ] = combineBaseReducerAndFieldsCoreFn(cfg, state, action, ...other);

        return !newState
            ? newState
            : produceFn(newState, action, keys, activeSubReducers, ...other);
    };
    return r;
}

const produceFn = produce(
    (draftState, action, keys, activeSubReducers, ...other) => {
        for (let key of keys)
            draftState[key] = activeSubReducers[key](
                draftState[key],
                action,
                ...other
            );
    }
);
